const rightsShopList = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/list.vue")), "rights");
const rightsShopDetail = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/detail.vue")), "rights");
const packageDetail = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/package-detail.vue")), "rights");
const rightsOrderSubmit = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/order-submit.vue")), "rights");
const rightsBuySuccess = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/success.vue")), "rights");
const rightsOrderDetail = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/order-detail.vue")), "rights");
const rightsList = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/my-rights/list.vue")), "rights");
const rightsDetail = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/my-rights/detail.vue")), "rights");
const rightsInformation = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/my-rights/information.vue")), "rights");
const physicalPackageList = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/my-rights/package-list.vue")), "rights");
const physicalPackageDetail = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/my-rights/package-detail.vue")), "rights");
const physicalOrderSubmit = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/my-rights/order-submit.vue")), "rights");
const rightsRedemptionCenter = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/redemption/center.vue")), "rights");
const rightsRedemptionSuccess = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/rights/redemption/success.vue")), "rights");



export default
[
    {
        path: "/rights/shop-list",
        name: "rights-shop-list",
        component: rightsShopList,
        meta:
        {
            title: "权益列表"
        }
    },
    {
        path: "/rights/shop-detail",
        name: "rights-shop-detail",
        component: rightsShopDetail,
        meta:
        {
            title: "权益详情"
        }
    },
    {
        path: "/rights/package-detail",
        name: "rights-package-detail",
        component: packageDetail,
        meta:
        {
            title: "套餐详情"
        }
    },
    {
        path: "/rights/order-submit",
        name: "rights-order-submit",
        component: rightsOrderSubmit,
        meta:
        {
            title: "确认订单"
        }
    },
    {
        path: "/rights/buy-success",
        name: "rights-buy-success",
        component: rightsBuySuccess,
        meta:
        {
            title: "购买成功"
        }
    },
    {
        path: "/rights/order-detail",
        name: "rights-order-detail",
        component: rightsOrderDetail,
        meta:
        {
            title: "订单详情"
        }
    },
    {
        path: "/rights/list",
        name: "rights-list",
        component: rightsList,
        meta:
        {
            title: "权益中心"
        }
    },
    {
        path: "/rights/detail",
        name: "rights-detail",
        component: rightsDetail,
        meta:
        {
            title: "权益中心"
        }
    },
    {
        path: "/rights/information",
        name: "rights-information",
        component: rightsInformation,
        meta:
        {
            title: "卡片信息"
        }
    },
    {
        path: "/physical/rights-package-list",
        name: "rights-physical-package-list",
        component: physicalPackageList,
        meta:
        {
            title: "套餐列表"
        }
    },
    {
        path: "/physical/package-detail",
        name: "physical-package-detail",
        component: physicalPackageDetail,
        meta:
        {
            title: "套餐详情"
        }
    },
    {
        path: "/physical/order-submit",
        name: "physical-order-submit",
        component: physicalOrderSubmit,
        meta:
        {
            title: "提交订单"
        }
    },
    {
        path: "/rights/redemption-center",
        name: "rights-redemption-center",
        component: rightsRedemptionCenter,
        meta:
        {
            title: "兑换中心"
        }
    },
    {
        path: "/rights/redemption-success",
        name: "rights-redemption-success",
        component: rightsRedemptionSuccess,
        meta:
        {
            title: "兑换中心"
        }
    }
];
